import { isMobile, isMobileOnly } from "react-device-detect";

export const ACCEPTED_IMAGE_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
export const MAX_IMAGE_FILE_SIZE = 1024 * 1024; // 1 MB
export const VIEW_ALL_GAMES_LIMIT = isMobileOnly ? 9 : 21;
export const CASINO_LOBBY_GAMES_LIMIT = isMobileOnly ? 4 : 8;
export const CASINO_LOBBY_PROVIDER_LIMIT = 3;
export const DATE_FORMAT = "DD/MM/YYYY";
export const TRANSACTION_LIMIT = 10;

export const TRANSACTION_TYPES = {
  0: "TRANSACTIONS.DEBIT",
  1: "TRANSACTIONS.CREDIT",
  2: "TRANSACTIONS.ROLLBACK",
  3: "TRANSACTIONS.DEPOSIT",
  4: "TRANSACTIONS.WITHDRAW",
  7: "TRANSACTIONS.TIP",
  8: "TRANSACTIONS.DEBIT_NO_CASH",
  9: "TRANSACTIONS.CREDIT_NO_CASH",
  10: "TRANSACTIONS.ROLLBACK_NO_CASH",
  11: "TRANSACTIONS.NON_CASH_BONUS_CLAIM",
  12: "TRANSACTIONS.DEPOSIT_BONUS_CLAIM",
  13: "TRANSACTIONS.TIP_NON_CASH",
  14: "TRANSACTIONS.WITHDRAW_CANCEL",
  15: "TRANSACTIONS.BET_BONUS",
  16: "TRANSACTIONS.REFER_A_FRIEND_BONUS",
  17: "TRANSACTIONS.CASH_BACK_BONUS",
  18: "TRANSACTIONS.SEASONAL_BONUS",
  19: "TRANSACTIONS.JOINING_BONUS"
};
export const FILTER_TRANSACTION_TYPE = {
  3: "TRANSACTIONS.DEPOSIT",
  4: "TRANSACTIONS.WITHDRAW",
  12: "TRANSACTIONS.DEPOSIT_BONUS_CLAIM",
  19: "TRANSACTIONS.JOINING_BONUS"
};
export const BONUS_IMG = {
  1: "bonus-img-joining.webp",
  2: "bonus-img-deposit.webp",
  3: "bonus-img-bet.webp",
  4: "bonus-img-loyalty.webp",
  5: "bonus-img-refer.webp",
  6: "bonus-img-cashback.webp",
  7: "bonus-img-season.webp"
};
export const LANGUAGE_CODE = {
  en: "en-US",
  es: "es-ES",
  pt: "pt-PT",
  fr: "fr-FR",
  ja: "ja-JP",
  de: "de-DE"
};
// ------SporsBook------

export const TOP_EVENTS_PAGE_LIMIT = 9;
export const PREVENT_SYMBOLS = ["e", "E", "+", "-"];
export const MATCH_STOPPED_TYPE = ["WO", "C"];
export const MAX_IMAGE_FILE_SIZE_SUPPORT = 1024 * 1024 * 2; // 2 MB
export const MAX_BET_AMOUNT_LIMIT = 100000;
export const MAX_BET_WIN_LIMIT = 400000;
export const agentBetcoinTokenRoles = ["agent", "betcoin_agent"];
export const EXTRA_MARKET_NAMES = {
  All: "SB_EXTRA_MARKET_NAMES.ALL",
  "Main Markets": "SB_EXTRA_MARKET_NAMES.MAIN_MARKETS",
  Totals: "SB_EXTRA_MARKET_NAMES.TOTALS",
  "1st Half": "SB_EXTRA_MARKET_NAMES.1ST_HALF",
  "2nd Half": "SB_EXTRA_MARKET_NAMES.2ND_HALF",
  Score: "SB_EXTRA_MARKET_NAMES.SCORE",
  Corners: "SB_EXTRA_MARKET_NAMES.CORNERS",
  "Home Team": "SB_EXTRA_MARKET_NAMES.HOME_TEAM",
  "Away Team": "SB_EXTRA_MARKET_NAMES.AWAY_TEAM",
  "All Periods": "SB_EXTRA_MARKET_NAMES.ALL_PERIODS",
  Results: "SB_EXTRA_MARKET_NAMES.RESULTS",
  "Home / Away": "SB_EXTRA_MARKET_NAMES.HOME/AWAY"
};

export const betLimitTranslation = {
  slots: "HEADER.SLOTS",
  maximumPossibleWinnings: "HEADER.MAXIMUM_POSSIBLE_WINNINGS",
  sports: "HEADER.SPORTS",
  liveCasino: "HEADER.LIVE_CASINO"
};

export const betTranslation = {
  slots: "HEADER.PER_SPIN",
  sports: "HEADER.PER_BET",
  liveCasino: "HEADER.PER_BALL"
};

export const matchStatsTranslation = {
  redcards: "SPORTSEVENTS.RED_CARDS",
  yellowcards: "SPORTSEVENTS.YELLOW_CARDS",
  yellowredcards: "SPORTSEVENTS.YELLOW_RED_CARDS",
  corners: "SPORTSEVENTS.CORNERS"
};

export const SoccerStatsImage = {
  redcards: "/images/sportsbook/Rectangle-Red.svg",
  yellowcards: "/images/sportsbook/Rectangle-Yellow.svg",
  yellowredcards: "/images/sportsbook/Capa 1 (2).svg",
  corners: "/images/sportsbook/Vector.svg"
};

export const BRANDNAME = process.env.REACT_APP_BRAND_NAME + " ";

export const CRASH_GAME = {
  iconName: "/images/sportsbook/slot-games.svg",
  name: "COMMON.CRASH_GAME",
  nameKey: process.env.REACT_APP_CRASH_GAME || ""
};

export const MAINTENANCE_IGNORE_IDS = ["5536", "679204"];

export const THEME = {
  // DARK_BLUE_YELLOW_THEME: 0,
  DARK_TEAL_PINK_THEME: 0,
  RED_GREEN_THEME: 1
};
export const CASINO_SLIDER_SETTINGS = {
  dots: false,
  infinite: false,
  dragable: false,
  speed: 500,
  // swipeToSlide: true,
  // beforeChange: (index) => setCurrentSlide(index),
  slidesToShow: isMobile ? 3 : 7,
  slidesToScroll: 5,
  initialSlide: 0,
  pauseOnHover: true,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    }
  ]
};
